import React from 'react';
import { Button, Col, Row } from 'react-bootstrap';

type CartEmptyStateProps = {
  readonly empty: string;
  readonly discoverButton: string;
  readonly onDiscoverClick: () => void;
};

export function CartEmptyState(props: CartEmptyStateProps) {
  const { empty, discoverButton, onDiscoverClick } = props;
  return (
    <>
      <Row className="text-center pt-4">
        <h1>{empty}</h1>
      </Row>
      <Row className="justify-content-center pb-4">
        <Col sm={12} md={8} lg={6} className="text-center">
          <img className="my-5" src="/images/cart_empty_new.png" alt={empty} />
          <Button
            size="lg"
            onClick={() => {
              onDiscoverClick();
            }}
          >
            {discoverButton}
          </Button>
        </Col>
      </Row>
    </>
  );
}
